import { render, staticRenderFns } from "./statementReturned.vue?vue&type=template&id=856db2f6&scoped=true&"
import script from "./statementReturned.vue?vue&type=script&lang=js&"
export * from "./statementReturned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856db2f6",
  null
  
)

export default component.exports